module.exports = __webpack_public_path__ + "static/media/up_in_tree.b76e0c2f.jpg";